import { createSlice } from "@reduxjs/toolkit";
import {
  createRequestWithdrawalBuilder,
  fetchRequestWithdrawalBuilder,
} from "./builder";
import { LOGOUT } from "../../../utils/constants";

const initialState = {
  requestWithdrawal: {
    data: [],
    maxReached: false,
    page: 1,
    total: 0,
    loading: false,
  },

  createRequestWithdrawalPending: false,
};

export const paymentSlice = createSlice({
  name: "paymentInfo",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: (builder) => {
    createRequestWithdrawalBuilder(builder);
    fetchRequestWithdrawalBuilder(builder);
    builder.addCase(LOGOUT, (state) => ({
      ...initialState,
    }));
  },
});

export const { resetState } = paymentSlice.actions;

export const selectCreateRequestWithdrawalPending = (state) =>
  state.paymentInfo.createRequestWithdrawalPending;

export const selectRequestWithdrawal = (state) =>
  state.paymentInfo.requestWithdrawal;

export default paymentSlice.reducer;
